import moment from 'moment';

export default (data, filename) => {
	const url = window.URL.createObjectURL(new Blob([data]));
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', filename || `Scipods.csv`);
	document.body.appendChild(link);
	link.click();
};
